/* eslint-disable max-len */

import React, { useRef, useState } from 'react';
import { BookingState } from '../../modules/booking-state/BookingState';
import { useModalManager } from '../../modules/contexts/modal-manager-context/ModalManagerProvider';
import { AgreementWithServicePlanModalContent } from './agreement-with-service-plan-modal-content/AgreementWithServicePlanModalContent';
import { PriceEstimateWithServicePlanPageContext } from './PriceEstimateWithServicePlanPageContext';
import { PriceEstimateWithServicePlanPageFormData } from './PriceEstimateWithServicePlanPageFormData';
import { withPageContext } from '../../modules/contexts/WithPageContext';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { FormRef } from '../../modules/forms/Form';
import { Wizard, WizardNavigate } from '../../modules/wizard/Wizard';
import { Steps } from '../../modules/wizard/Steps';
import { useBookingContext } from '../../modules/booking-state/UseBookingContext';
import { PriceEstimateWithServicePlanPageViewProps } from './PriceEstimateWithServicePlanPageViewProps';

function ContextAccessor({
  vehicleDetails,
  vehicleServiceHistory,
  serviceRequest,
  selectedDealer,
}: BookingState): PriceEstimateWithServicePlanPageContext | null {
  if (!(vehicleDetails && vehicleServiceHistory && serviceRequest && selectedDealer)) {
    return null;
  }

  return {
    serviceRequest,
    vehicleServiceHistory,
  };
}

export const PriceEstimateWithServicePlanPage = withPageContext(ContextAccessor, ({ pageContext }) => {
  const viewProvider = useViewProvider();
  const [bookingState] = useBookingContext();
  const [initialFormData] = useState<PriceEstimateWithServicePlanPageFormData>(() => ({
    termsAndConditionsAccepted: false,
  }));
  const formRef = useRef<FormRef<PriceEstimateWithServicePlanPageFormData>>(null);
  const modalManager = useModalManager();
  const modalContent = AgreementWithServicePlanModalContent();

  const onNext: WizardNavigate = (nextStep) => {
    formRef.current!.submit(() => {
      nextStep(bookingState);
    });
  };
  const onPrevious: WizardNavigate = (previousStep) => {
    previousStep(bookingState);
  };
  const onTermsAndConditionsClick = (): void => {
    modalManager.open({
      title: 'Terms and conditions',
      content: () => modalContent,
    });
  };

  const viewProps: PriceEstimateWithServicePlanPageViewProps = {
    formRef,
    initialFormData,
    serviceRequest: pageContext.serviceRequest,
    vehicleServiceHistory: pageContext.vehicleServiceHistory,
    onTermsAndConditionsClick,
  };

  return (
    <Wizard currentStep={Steps.EstimatedPrice} onNext={onNext} onPrevious={onPrevious} disabled={false}>
      {viewProvider.renderPriceEstimateWithServicePlanPage(viewProps)}
    </Wizard>
  );
});
